import {
  AfterViewInit,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { IDocumentResponse } from '@literax/models/document.model';
import { ILegalPerson, INaturalPerson, IObserver } from '@literax/models/participant.model';
import { selectCurrentParticipant, WorkspaceSelectors } from '@literax/modules/documents/store/workspace/workspace.selectors';
import { IAppState } from '@literax/store';

import { AppUtils } from '@literax/utils/app.utils';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { select, Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
@UntilDestroy()
@Component({
  selector: 'literax-signature-canvas',
  templateUrl: './signature-canvas.component.html',
  styleUrls: ['./signature-canvas.component.scss'],
})
export class SignatureCanvasComponent implements AfterViewInit {
  canvas: any;
  context: any;
  cw: number;
  ch: number;
  clean = false;
  insulationFactor = 5;
  canvasBlank = document.createElement('canvas');
  trazados = [];
  puntos = [];
  dibujar = false;
  currentSigner: INaturalPerson | ILegalPerson | IObserver;
  selectDocument: IDocumentResponse;
  isAutoSignatureEnabled = false;
  textToSign = '';

  document$ = this.store.pipe(
    untilDestroyed(this),
    select(WorkspaceSelectors.selectDocument)
  );
  currentParticipant$ = this.store.pipe(
    untilDestroyed(this),
    select(selectCurrentParticipant)
  );

  @Output() signatureDone: EventEmitter<Blob> = new EventEmitter<Blob>();
  constructor(private store: Store<IAppState>) {
    this.document$
      .pipe(
        untilDestroyed(this),
        filter((document) => !!document)
      )
      .subscribe((document: IDocumentResponse) => {
        this.selectDocument = document;
        this.isAutoSignatureEnabled =
          this.selectDocument.signingConfiguration?.isAutoSignatureEnabled;
      });

    this.currentParticipant$
      .pipe(untilDestroyed(this))
      .subscribe((cParticipant: INaturalPerson | ILegalPerson) => {
        this.currentSigner = cParticipant;
        console.log('currentSigner', this.currentSigner);
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setCanvas();
    }, 100);

    if (!this.currentSigner?.name) return;

    this.textToSign = this.currentSigner.name.split(' ').slice(0, 2).join(' ');
  }

  preventDefault(e) {
    e.preventDefault();
  }

  disableScroll() {
    document.body.addEventListener('touchmove', this.preventDefault, {
      passive: false,
    });
  }

  enableScroll() {
    document.body.removeEventListener('touchmove', this.preventDefault);
  }

  setCanvas() {
    this.canvas = document.getElementById('canvas');
    this.context = this.canvas.getContext('2d');
    this.context.lineJoin = 'round';
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const width = this.canvas.offsetWidth * ratio;
    const height = this.canvas.offsetHeight * ratio;
    this.cw = width;
    this.ch = height;
    this.canvas.width = width;
    this.canvas.height = height;
    this.context.scale(ratio, ratio);
  }

  drawSignature() {
    this.dibujar = true;
    this.puntos.length = 0;
    this.disableScroll();
    this.context.beginPath();
  }

  traceSignature(position) {
    this.puntos.push(position);
    this.context.lineTo(position.x, position.y);
    this.context.stroke();
  }

  traceSignatureMouse(event) {
    if (this.dibujar) {
      const position = this.oMousePos(this.canvas, event);
      this.traceSignature(position);
    }
  }
  
  traceSignatureTouch(event) {
    if (this.dibujar) {
      const position = this.onTouchPos(this.canvas, event);
      this.traceSignature(position);
    }
  }

  reducirArray(n, elArray) {
    const nuevoArray = [];
    for (let i = 0; i < elArray.length; i++) {
      if (i % n === 0) {
        nuevoArray[nuevoArray.length] = elArray[i];
      }
    }
    nuevoArray[nuevoArray.length - 1] = elArray[elArray.length - 1];
    this.trazados.push(nuevoArray);
  }
  calcularPuntoDeControl(ry, a, b) {
    const pc: any = {};
    pc.x = (ry[a].x + ry[b].x) / 2;
    pc.y = (ry[a].y + ry[b].y) / 2;
    return pc;
  }
  alisarTrazado(ry) {
    if (ry.length > 1) {
      const ultimoPunto = ry.length - 1;
      this.context.beginPath();
      this.context.moveTo(ry[0].x, ry[0].y);
      for (let i = 1; i < ry.length - 2; i++) {
        const pc = this.calcularPuntoDeControl(ry, i, i + 1);
        this.context.quadraticCurveTo(ry[i].x, ry[i].y, pc.x, pc.y);
      }
      this.context.quadraticCurveTo(
        ry[ultimoPunto - 1].x,
        ry[ultimoPunto - 1].y,
        ry[ultimoPunto].x,
        ry[ultimoPunto].y
      );
      this.context.stroke();
    }
  }
  redibujarTrazado() {
    this.dibujar = false;
    this.enableScroll();
    this.context.clearRect(0, 0, this.cw, this.ch);
    this.reducirArray(this.insulationFactor, this.puntos);
    this.trazados.forEach((elemento) => this.alisarTrazado(elemento));
    this.saveSignature();
  }
  cleanSignature() {
    this.dibujar = false;
    this.context.clearRect(0, 0, this.cw, this.ch);
    this.trazados.length = 0;
    this.puntos.length = 0;
    this.clean = !this.clean;
    this.signatureDone.emit(null);
  }

  saveSignature() {
    const image = this.canvas.toDataURL('image/png');
    if (this.canvas.toDataURL() !== this.canvasBlank.toDataURL()) {
      const file = this.dataURItoBlob(image);
      this.signatureDone.emit(file);
      this.clean = true;
    }
  }
  oMousePos(canvas, evt) {
    const ClientRect = canvas.getBoundingClientRect();
    return {
      x: Math.round(evt.clientX - ClientRect.left),
      y: Math.round(evt.clientY - ClientRect.top),
    };
  }
  onTouchPos(canvas, evt) {
    const ClientRect = canvas.getBoundingClientRect();
    return {
      x: Math.round(evt.touches[0].clientX - ClientRect.left),
      y: Math.round(evt.touches[0].clientY - ClientRect.top),
    };
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else byteString = decodeURI(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new File(
      [ia],
      `signature_image.${AppUtils.extensionFromMimeType(mimeString)}`,
      { type: mimeString }
    );
  }

  automaticSignature(optionSelected: number) {
    if (!this.textToSign) return;

    const fontSize = Math.max(
      24,
      Math.floor(((this.cw * 2) / 3 / this.textToSign.length) * 1.8)
    );

    const fontOptions = [
      { family: 'Style Script', url: 'assets/fonts/StyleScript-Regular.ttf' },
      {
        family: 'Cedarville Cursive',
        url: 'assets/fonts/CedarvilleCursive-Regular.ttf',
      },
      {
        family: 'Edu NSW ACT Cursive',
        url: 'assets/fonts/EduNSWACTCursive-VariableFont_wght.ttf',
      },
    ];

    const selected = fontOptions[optionSelected - 1];
    if (!selected) return;

    const fontFace = new (window as any).FontFace(
      selected.family,
      `url(${selected.url})`,
      { style: 'normal', weight: '400' }
    );

    fontFace.load().then((customFont: any) => {
      (document as any).fonts.add(customFont);
      this.context.clearRect(0, 0, this.cw, this.ch);
      this.context.save();
      this.context.font = `${fontSize}px "${selected.family}"`;
      this.context.textAlign = 'center';
      this.context.textBaseline = 'middle';
      const x = this.cw / 2.5;
      const y = this.ch / 2.5; 
      this.context.fillText(this.textToSign, x, y);
      this.context.restore();
      this.signatureDone.emit(
        this.dataURItoBlob(this.canvas.toDataURL('image/png'))
      );
      this.clean = true;
    });
  }
}
